<template>
    <div>
        <modal class="reset-user-pwd" :display="modalStatus.resetUserPwd" @modalStatus="closeModal" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>修改密碼</h1>
            <div class="reset-user-pwd-wrap">
                <div class="new-password">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            原密碼
                        </div>
                        <span v-show="error.reset.originPassword" class="error-with-title">{{error.reset.originPassword}}</span>
                    </label>
                    <div class="input-arear">
                        <input ref="originPassword" :class="{error: error.reset.originPassword}" type=password v-model="reset.originPassword" placeholder="請輸入原密碼">
                        <div v-if="password.pwdShow" @click="togglePassword('pwd')" class="show-hide-pwd">
                            <span v-if="password.pwdVisible">
                                隱藏
                            </span>
                            <span v-else>
                                顯示
                            </span>
                        </div>
                    </div>
                </div>
                <div class="new-password">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            新密碼
                        </div>
                        <span v-show="error.reset.newPassword" class="error-with-title">{{error.reset.newPassword}}</span>
                    </label>
                    <div class="input-arear">
                        <input ref="newPassword" :class="{error: error.reset.newPassword}" type=password v-model="reset.newPassword" placeholder="請輸入新密碼">
                        <div v-if="password.newPwdShow" @click="togglePassword('nPwd')" class="show-hide-pwd">
                            <span v-if="password.newPwdVisible">
                                隱藏
                            </span>
                            <span v-else>
                                顯示
                            </span>
                        </div>
                    </div>
                </div>
                <div class="password-check">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            再次確認密碼
                        </div>
                        <span v-show="error.reset.confirmPassword" class="error-with-title">{{error.reset.confirmPassword}}</span>
                    </label>
                    <div class="input-arear">
                        <input  ref="confirmPassword" :class="{error: error.reset.confirmPassword}" type=password v-model="reset.confirmPassword" placeholder="再次確認密碼">
                        <div v-if="password.pwdCheckShow" @click="togglePassword('pwdCheck')" class="show-hide-pwd">
                            <span v-if="password.pwdCheckVisible">
                                隱藏
                            </span>
                            <span v-else>
                                顯示
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <div class="loading-wrap">
                    <btn-loading v-if="status.isDisable"></btn-loading>
                    <button class="default-button confirm" :disabled="status.isDisable" @click="resetUserPwd()">
                        更新
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import { mapGetters } from 'vuex'
import { apiBizMemberResetPwd } from "@/apis/api.js"; 

export default {
    data () {
        return {
            reset: {
                originPassword: null,
                newPassword: null,
                confirmPassword: null
            },
            error: {
                reset: {
                    originPassword: null,
                    newPassword: null,
                    confirmPassword: null
                }
            },
            password: {
                pwdShow: false,
                pwdVisible: false,
                newPwdShow: false,
                newPwdVisible: false,
                pwdCheckShow: false,
                pwdCheckVisible: false,
            },
            status: {
                isDisable: false,
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 3000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 3000
                }
            },
        }
    },
    watch: {
        reset: {
            handler: function (val) {
                //密碼判斷
                if( val.originPassword ){
                    this.password.pwdShow = true
                    this.error.reset.originPassword = null;
                }
                //密碼判斷
                let isText = /^(?=.*\d)(?=.*[a-zA-Z]).{8,30}$/;
                if( val.newPassword ){
                    this.password.newPwdShow = true
                    if (!isText.test(val.newPassword)) {
                        this.error.reset.newPassword = '需包含英文加上數字八位字元';
                    }else {
                        this.error.reset.newPassword = null;
                    }
                }
                //密碼確認
                if( val.confirmPassword ){
                    this.password.pwdCheckShow = true
                    if(val.confirmPassword == val.newPassword){
                        this.error.reset.confirmPassword = null;
                    }else{
                        this.error.reset.confirmPassword = '需與填寫密碼相同';
                    }
                }
            },
            deep: true
        },
    },
    methods: {
        resetUserPwd: function () {
            if(this.checkInput()){
                
                let data = this.reset
                this.status.isDisable = true 

                apiBizMemberResetPwd(data)
                .then(res => {
                    console.log(res)
                    this.status.isDisable = false 
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '重設密碼成功',type: 'success'})
                        this.closeModal()
                    }else{
                        this.status.isDisable = false 
                        this.alarm.error.msg = '密碼重設失敗'
                        this.alarm.error.status = true
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.status.isDisable = false 
                    this.alarm.error.msg = '密碼重設失敗'
                        this.alarm.error.status = true
                })
            }
            
        },
        checkInput: function () {
            if(!this.reset.originPassword){
                this.error.reset.originPassword = '請輸入原密碼'
            }
            if(!this.reset.newPassword){
                this.error.reset.newPassword = '請輸入新密碼'
            }
            if(!this.reset.confirmPassword){
                this.error.reset.confirmPassword = '請輸入確認密碼'
            }
            // if(!this.reset.companyId){
            //     this.error.reset.companyId = '請輸入公司統一編號'
            // }
          
            if(
                this.reset.originPassword &&
                this.reset.newPassword &&
                this.reset.confirmPassword &&
                this.error.reset.originPassword == null &&
                this.error.reset.newPassword == null &&
                this.error.reset.confirmPassword == null 
            ){
                return true
            }else{
                return false
            }
        },
        togglePassword: function (type) {
            if(type == 'pwd'){
                let password = this.$refs.originPassword;
                if (password.type === "password") {
                    this.password.pwdVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdVisible = false
                    password.type = "password";
                }
            }else if(type == 'nPwd'){
                let password = this.$refs.newPassword;
                if (password.type === "password") {
                    this.password.newPwdVisible = true
                    password.type = "text";
                } else {
                    this.password.newPwdVisible = false
                    password.type = "password";
                }
            }else{
                let password = this.$refs.confirmPassword;
                if (password.type === "password") {
                    this.password.pwdCheckVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdCheckVisible = false
                    password.type = "password";
                }
            }
            
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'resetUserPwd'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        btnLoading,
        alarmMsgWhite
    }
}
</script>
<style lang="scss"  >
    #modal.reset-user-pwd{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                .alarm-msg{
                    left: 50%;
                    margin-left: -70px;
                }
                align-items: flex-start;
                >h1{
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 24px;
                    line-height: 1.5;
                }
                .reset-user-pwd-wrap{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    margin: 0 auto;
                    >div{
                        width: 384px;
                        margin-bottom: 24px;
                        .show-hide-pwd{
                            position: absolute;
                            font-size: 12px;
                            top: 16px;
                            right: 16px;
                            cursor: pointer;
                        }
                    }
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 308px;
                        height: 44px;
                        margin-bottom: 0px;
                        
                    }
                    .loading-wrap{
                        position: relative;
                        .btn-loading{
                            left: 64px;
                            top: 6px;
                        }
                    }
                }
            }
      
        }
    }
    @media screen and (max-width: 375px) {
        #modal.reset-user-pwd{
            .modal-content{
                width: 340px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/resetUserPwd.vue